import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://chat.dev-designversestudios.com/api",
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalized = new Error(
      error.response?.data?.message ||
        (error.code === "ECONNABORTED"
          ? "The request took too long."
          : "Unable to reach the server."),
    );
    normalized.status = error.response?.status;
    normalized.details = error.response?.data?.details;
    normalized.response = error.response;
    return Promise.reject(normalized);
  },
);

export const getData = (response) => response.data.data;
export default api;
